module.exports={"Star Rating":"Stjerneklassifikation","# star(s)":"{currentRating, plural, =1{# stjerne} other{# stjerner}}"};